import { ActionIcon, Box, Button, Flex, Text } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';
import { GroupedSuggestions } from 'src/common/components/markdown-editor/plugins/SuggestionTrackerPlugin';
import { ContentHeader } from 'src/UI/app-container';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import MarkersPanel from './MarkersPanel';
import VersionTile from './VersionTile';

type DocumentPanelProps = {
  backHref: string;
  title: string;
  version: string;
  versionDate: string;
  versionVariant: 'primary' | 'past';
  suggestions: GroupedSuggestions;
  showMarkers: boolean;
  onShowMarkersChange: (value: boolean) => void;
};

export default function DocumentPanel({
  backHref,
  title,
  version,
  versionDate,
  versionVariant,
  suggestions,
  showMarkers,
  onShowMarkersChange,
}: DocumentPanelProps) {
  return (
    <>
      <ContentHeader
        backHref={backHref}
        left={
          <Text size="sm" fw={FONT_WEIGHTS.bold} c="black">
            {title}
          </Text>
        }
        right={
          <Flex align="center">
            <VersionTile version={version} date={versionDate} variant={versionVariant} />
            <Box w={12} />
            <Button h={28} px="sm" size="xs">
              Save & finalise
            </Button>
            <Box w={24} />
            <ActionIcon variant="subtle" c="black">
              <IconDotsVertical size={20} />
            </ActionIcon>
          </Flex>
        }
      />

      <Box mt="md">
        <MarkersPanel
          suggestions={suggestions}
          showMarkers={showMarkers}
          onShowMarkersChange={onShowMarkersChange}
        />
      </Box>
    </>
  );
}
